export default {
  Error: {
    404: 'OPP! Không tìm thấy trang.',
    '404_sub': 'Đường dẫn đang truy cập đã bị thay đổi hoặc không tồn tại',
    500: 'Internal Server Error!',
    '500_sub':
      'Có một số lỗi xảy ra, vui lòng liên hệ với MISA để được trợ giúp',
    403: 'Không có quyền truy cập',
    '403_sub':
      'Bạn vui lòng liên hệ với admin để được cấp quyền truy cập ứng dụng',
  },
  Button: {
    BackAmis: 'Quay lại',
    ByNow: 'Mua ngay',
    ActiveNow: 'Gia hạn ngay',
    DeleteUser: 'Xóa người dùng',
    Cancel: "Cancel",
    Save: "Save",
    Delete: "Delete",
  },
};
